import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
  Avatar,
  styled,
  Typography,
  IconButton,
  Grid,
  Paper,
  CircularProgress,
} from "@mui/material";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import { motion } from "framer-motion";
import CloseIcon from "@mui/icons-material/Close";
import { CustomNumberField, CustomTextField } from "../../../components/common";
import { Box } from "@mui/system";
import { CustomButton } from "../../../components/common/LoadingButton";
const CustomDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    borderRadius: 15,
    Padding: "1rem",
    // textAlign: "center",
    position: "relative",
    overflow: "visible",
  },
});

export const CustomAvatar = styled(Avatar)({
  backgroundColor: "#2196f3",
  width: 100,
  height: 100,
  position: "absolute",
  top: "-4rem",
  left: "50%",
  transform: "translateX(-50%)",
  //   margin: "0 auto",
  // marginBottom: "16px",
});
export const CustomDialogActions = styled(DialogActions)({
  justifyContent: "center",
});

export const CustomImageDialog = ({ open, onClose, children, ...props }) => {
  return (
    <CustomDialog
      {...props}
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      aria-labelledby="cancel-dialog-title"
      PaperProps={{
        component: motion.div,
        initial: { opacity: 0, y: -50 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -50 },
        transition: { duration: 0.5 },
      }}
    >
      {children}
    </CustomDialog>
  );
};

const SearchByPrompt = ({ open, onClose, formik, submitOn }) => {
  const handleConfirm = () => {
    submitOn();
  };

  return (
    <CustomImageDialog open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontFamily: "Urbane-Demibold",
          fontSize: "16px",
          fontWeight: 600,
        }}
      >
        Search Details
        <IconButton
          edge="end"
          color="error"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid item xs={12} md={8} noValidate autoComplete="off">
          <Box sx={{ padding: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <CustomTextField
                  id="title"
                  label="Project Title"
                  name="title"
                  autoComplete="title"
                  placeholder="Enter your project title"
                  formik={formik}
                  autoFocus
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <CustomTextField
                  id="name"
                  label="Your Name"
                  name="name"
                  autoComplete="name"
                  placeholder="Enter your name"
                  formik={formik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomTextField
                  id="designation"
                  label="Your Title (e.g. HR Head)"
                  name="designation"
                  autoComplete="designation"
                  placeholder="Enter your Your title (e.g. HR Head)"
                  formik={formik}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <CustomNumberField
                  id="mobileno"
                  label="Phone Number"
                  name="mobileno"
                  autoComplete="mobileno"
                  placeholder="Enter your phone number"
                  numberFlag={true}
                  formik={formik}
                  inputProps={{
                    maxLength: 15,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <CustomTextField
                  id="email"
                  label={"Email"}
                  name="email"
                  autoComplete="email"
                  placeholder="Enter your email"
                  formik={formik}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </DialogContent>
      <CustomDialogActions>
        <CustomButton
          type="button"
          disabled={formik.isSubmitting}
          startIcon={formik.isSubmitting && <CircularProgress size={24} />}
          onClick={handleConfirm}
        >
          {formik.isSubmitting ? "Submit..." : " Submit"}
        </CustomButton>
      </CustomDialogActions>{" "}
    </CustomImageDialog>
  );
};

export default SearchByPrompt;
